export default "__VITE_ASSET__D3c3IxOT__"